import { Box, Card, Collapse, Group, Title } from "@mantine/core";
import { CaretDown } from "tabler-icons-react";
import { useState } from "react";
import { DEFAULT_WHITE_COLOR } from "../../../_graphic_design";

export default function Collapsable({
  title,
  children,
  actions,
  defaultOpened = true,
}: {
  title: string;
  children: JSX.Element | JSX.Element[];
  actions?: JSX.Element;
  defaultOpened?: boolean;
}) {
  const [opened, setOpened] = useState(defaultOpened);

  const toggle = () => setOpened((prev) => !prev);

  return (
    <Box>
      <Group position={"apart"}>
        <Group spacing="xs" style={{ cursor: "pointer" }}>
          <CaretDown
            size={11}
            onClick={toggle}
            style={{
              transform: opened ? "rotate(0)" : "rotate(-90deg)",
              transition: "transform 100ms ease-out",
            }}
          />
          <Title
            order={4}
            p={5}
            onClick={toggle}
            sx={{
              cursor: "pointer",
            }}
          >
            <span style={{ marginLeft: -12 }}>{title}</span>
          </Title>
        </Group>
        {actions}
      </Group>
      <Collapse in={opened}>
        <Card shadow={"sm"} p={"xl"} className={"overflow-visible"}>
          {children}
        </Card>
      </Collapse>
      <Collapse in={!opened}>
        <Box
          sx={(theme) => ({
            borderBottom: opened
              ? undefined
              : `3px solid ${DEFAULT_WHITE_COLOR}`,
            boxShadow: theme.shadows.sm,
            borderRadius: 50,
          })}
        />
      </Collapse>
    </Box>
  );
}
